"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Music, Mic, Lightbulb, Volume2, Users, Clock, MapPin, Sparkles } from "lucide-react";
export default function PackageDetails() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  const packages = [{
    id: "essential",
    label: "Essential Package",
    description: "Perfect for intimate gatherings and smaller venues. Includes professional DJ services with curated playlists tailored to your event.",
    icons: [{
      Icon: Music,
      label: "Curated Music"
    }, {
      Icon: Mic,
      label: "MC Services"
    }, {
      Icon: Volume2,
      label: "Premium Sound"
    }, {
      Icon: Clock,
      label: "4 Hours"
    }],
    addOns: ["Additional Hour", "Wireless Mic"]
  }, {
    id: "premium",
    label: "Premium Package",
    description: "Elevate your celebration with enhanced lighting design, extended coverage, and comprehensive audio setup for medium to large venues.",
    icons: [{
      Icon: Music,
      label: "Custom Playlists"
    }, {
      Icon: Lightbulb,
      label: "Uplighting"
    }, {
      Icon: Volume2,
      label: "Advanced Sound"
    }, {
      Icon: Users,
      label: "6 Hours"
    }],
    addOns: ["Dance Floor Lighting", "Extra Speaker", "Photo Booth"]
  }, {
    id: "ultimate",
    label: "Ultimate Package",
    description: "The complete entertainment experience with dynamic lighting effects, full AV production, dedicated sound engineering, and all-day coverage.",
    icons: [{
      Icon: Sparkles,
      label: "Dynamic Lighting"
    }, {
      Icon: Volume2,
      label: "Full AV Setup"
    }, {
      Icon: Volume2,
      label: "Up to 4 PA Speakers"
    }, {
      Icon: MapPin,
      label: "Any Venue"
    }, {
      Icon: Clock,
      label: "8+ Hours"
    }],
    addOns: ["Cold Sparklers", "Monogram Projection", "Live Streaming"]
  }];
  return;
}